import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { MB_CHECKOUT_BILLING_FORM_NORMALIZER, MbCheckoutBillingFormAdapter } from '../connectors'
import { MbBillingInformation } from '../../models'

@Injectable({
  providedIn: 'root',
})
export class MbOccCheckoutBillingFormAdapter implements MbCheckoutBillingFormAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (cartId: string, userId: string) {
    return this.http.get(this.getEndpoint(cartId, userId)).pipe(
      this.converter.pipeable(MB_CHECKOUT_BILLING_FORM_NORMALIZER)
    )
  }

  post (form: MbBillingInformation, cartId: string, userId: string) {
    form = this.converter.convert(form, MB_CHECKOUT_BILLING_FORM_NORMALIZER)
    return this.http.post(this.getEndpoint(cartId, userId), form)
  }

  protected getEndpoint (cartId: string, userId: string) {
    return this.occEndpoints.buildUrl(
      'checkoutBillingForm',
      {
        urlParams: { cartId, userId },
      }
    )
  }
}
